export const environment = {
    production: false,
    apiUrl: 'https://gateway.dev.takenote.cloud/tvxplus-demo',
};